<template>
  <div class="header">
    <div class="w wrapper flex">
      <div class="left" @click="toPage(1, '/home')">
        <div class="logo">
          <img
              src="/img/2公司介绍-logo.png"
              alt="logo"
              class="logoImg"
          />
          <div class="logoText">
            <div class="logoTextTop">{{$t('header.companyName')}}</div>
            <div class="logoTextBottom">
              Yiwu KMT Daily NecessitiesCo.Ltd
            </div>
          </div>
        </div>

<!--        <img src="/img/1首页-nav-logo2.png" alt="" />-->
      </div>
      <div class="flex right">
        <ul class="rightUl">
          <li
            v-for="(item, index) in routesList"
            v-if="index !== 5"
            :key="item.index"
            :class="{ introduce: item.index === 2 }"
          >
            <span
              :class="{ activeIndex: item.index === currentIndex }"
              @click="toPage(item.index, item.path)"
            >
              {{ $t(`header.nav[${index}]`) }}
            </span>
            <template v-if="item.children">
              <div class="company">
                <div
                  v-for="(children, i) in item.children"
                  :key="children.index"
                  class="item"
                  :class="{ activeIndex: children.index === currentIndex }"
                  @click="toPage(children.index, children.path)"
                >
                  {{ $t(`header.companyChild[${i}]`) }}
                </div>
              </div>
            </template>
          </li>
        </ul>
        <el-select v-model="lang" @change="changeLang">
          <el-option
            v-for="item in langOptions"
            :key="item.lang"
            :label="item.label"
            :value="item.lang"
            style="text-align:center;"
          >
          </el-option>
        </el-select>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Header',
    data() {
      return {
        routesList: [
          {
            path: '/home',
            index: 1,
          },
          {
            path: '/company',
            index: 2,
            children: [
              // {
              //   path: '/company/dynamic',
              //   index: 9,
              // },
              // {
              //   path: '/company/architecture',
              //   index: 10,
              // },
              // {
              //   path: '/company/activity',
              //   index: 11,
              // },
              {
                path: '/company/responsibility',
                index: 12,
              },
              // {
              //   path: '/company/popularizeLaw',
              //   index: 13,
              // },
              // {
              //   path: '/company/police',
              //   index: 14,
              // },
            ],
          },
          {
            path: '/companyCulture',
            index: 3,
          },
          {
            path: '/productDisplay',
            index: 4,
          },
          {
            path: '/businessField',
            index: 5,
          },
          // {
          //   path: '/investment',
          //   index: 6,
          // },
          {
            path: '/joinUs',
            index: 7,
          },
          {
            path: '/contactUs',
            index: 8,
          },
        ],
        lang: 'es',
        langOptions: [
          { label: '中文', lang: 'zh' },
          { label: 'English', lang: 'en' },
          { label: 'Español', lang: 'es' },
          { label: 'Français', lang: 'fr' },
          { label: 'Italiano', lang: 'it' },
          { label: 'Polski', lang: 'pl' },
          { label: 'Deutsch', lang: 'de' },
          { label: 'Nederlands', lang: 'nl' },
          { label: 'Português', lang: 'pt' },
          { label: 'български', lang: 'bg' },
        ],
      }
    },
    props: {
      currentIndex: {
        type: Number,
        default: 1,
      },
    },
    mounted() {
      const index = sessionStorage.getItem('index')
      index && this.$emit('update:currentIndex', Number(index))
        // 初始化强制设置西班牙语，同步全局i18n
        this.changeLang('es')
    },
    methods: {
      toPage(index, path) {
        if (this.$route.path === path) return
        sessionStorage.setItem('index', index)
        this.$emit('update:currentIndex', index)
        this.$router.push(path)
      },
      changeLang(value) {
        this.$i18n.locale = value
      },
    },
  }
</script>

<style scoped lang="scss">
  .header {
    height: 70px;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background-color: #fff;
    z-index: 9999;
  }
  .left {
    cursor: pointer;
  }
  .wrapper {
    justify-content: space-between;
    align-items: center;
    height: 70px;
  }
  li {
    padding: 0;
  }
  .right {
    align-items: center;
  }
  .rightUl {
    & > li {
      float: left;
      position: relative;
      padding: 0 12px;
      line-height: 70px;
      text-align: center;
      font-size: 18px;
      &:hover {
        background-color: var(--bg-color);
      }
      & > span {
        padding: 10px 5px;
        cursor: pointer;
      }
    }
  }
  .introduce {
    &:hover {
      .company {
        display: block;
      }
    }
  }
  .company {
    display: none;
    position: absolute;
    width: 150px;
    top: 70px;
    left: 0;
    border-radius: 0 0 10px 10px;
    box-shadow: 0 0 3px rgb(197, 197, 197);
    background-color: #fff;
    z-index: 999;
    overflow: hidden;
  }
  .item {
    line-height: 25px;
    padding: 10px 50px 10px 10px;
    cursor: pointer;
    text-align: left;
    &:hover {
      background-color: var(--bg-color);
    }
  }
  .el-select {
    width: 115px;
    ::v-deep .el-input__inner {
      padding: 0 15px;
      border: 0;
      text-align: center;
      color: #000;
    }
  }
  .activeIndex {
    color: var(--font-color);
  }
  .logo {
    display: flex;
    align-items: center;
    .logoImg {
      height: 40px;
    }
    .logoText {
      padding-left: 30px;
      display: flex;
      flex-direction: column;
      border-left: 4px solid black;
      .logoTextTop {
        font-weight: bold;
        font-size: 18px;
      }
      .logoTextBottom {
        font-size: 16px;
        color: #666666;
      }
    }
  }
</style>
